// @flow

import { startRequest, finishRequest } from "@store/utils";
import type { ReferralTrackerState } from "./types";

export const setLoading = (state: ReferralTrackerState) => () => startRequest(state);

export const setLoaded = (state: ReferralTrackerState) => () => finishRequest(state);

export const onError = (state: ReferralTrackerState) => ({ payload }: Object) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetSupplierNewReferralsSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    newReferrals: payload,
  };
};

export const onGetSupplierNewReferralsError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetSupplierActiveReferralsSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    activeReferrals: payload,
  };
};

export const onGetSupplierActiveReferralsError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetSupplierClosedReferralsSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    closedReferrals: payload,
  };
};

export const onGetSupplierClosedReferralsError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetSupplierReferralDetailsSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    referralDetails: payload,
  };
};

export const onGetSupplierReferralDetailsError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});

export const onToggleSupplierReferralDetailsModal = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showReferralDetails: !state.modals.showReferralDetails,
  },
  commonData: {
    ...state.commonData,
    referralType: (payload && payload.referralType) || "",
    supplierReferralId: payload && payload.supplierReferralId,
  },
});

export const onSubmitSupplierReferralStatusSuccess = (state: ReferralTrackerState) => () => {
  return {
    ...finishRequest(state),
    error: null,
    modals: {
      showReferralDetails: false,
      showRTWReferralDetails: false,
      showLogReferralDetails: false,
      showStatusReferralDetails: false,
    },
    referralDetails: {
      employeeDetails: {
        firstName: "",
        lastName: "",
        employeeRef: "",
        jobTitles: "",
        departments: "",
      },
      referralDetails: {
        dateReferred: "",
        referralType: "",
        referredBy: "",
        referralReason: "",
      },
      absenceHistory: [],
      referralQuestions: [],
      lineManagers: [],
      supplierTracking: "",
    },
    commonData: {
      outcomeOptions: [],
      supplierReferralId: null,
      referralType: "",
      clientId: null,
    },
  };
};

export const onSubmitSupplierReferralStatusError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});
// RTW Toggle
export const onToggleRTWReferralDetailsModal = (state: ReferralTrackerState) => () => {
  return {
    ...state,
    modals: {
      ...state.modals,
      showRTWReferralDetails: !state.modals.showRTWReferralDetails,
    },
  };
};
// RTW Success
export const onGetRTWReferralDetailsSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    referralRTWDetails: payload,
  };
};
// RTW Error
export const onGetRTWReferralDetailsError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});

// Log Toggle
export const onToggleLogReferralDetailsModal = (state: ReferralTrackerState) => () => {
  return {
    ...state,
    modals: {
      ...state.modals,
      showLogReferralDetails: !state.modals.showLogReferralDetails,
    },
  };
};
// Log Success
export const onGetLogReferralDetailsSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    referralLogDetails: payload,
  };
};
export const onSubmitRTWReferralDataSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  const content = state.activeReferrals.supplierReferralTasks.content.map(rec => {
    if (rec.referralId === payload.supplierReferralId) {
      return { ...rec, rtwDate: payload.rtwDate };
    }
    return rec;
  });
  return {
    ...finishRequest(state),
    activeReferrals: {
      ...state.activeReferrals,
      supplierReferralTasks: { ...state.activeReferrals.supplierReferralTasks, content },
    },
  };
};

export const onSubmitRTWReferralDataError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});

export const onSubmitLogReferralDataSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  let referralLogDetails = [...state.referralLogDetails];
  referralLogDetails.push(payload);
  return {
    ...finishRequest(state),
    error: null,
    referralLogDetails,
  };
};

export const onSetReferralCommonData = (state: ReferralTrackerState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    commonData: { ...state.commonData, ...payload },
  };
};

// Log Error
export const onGetLogReferralDetailsError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});

// Status Toggle
export const onToggleStatusReferralDetailsModal = (state: ReferralTrackerState) => () => {
  return {
    ...state,
    modals: {
      ...state.modals,
      showStatusReferralDetails: !state.modals.showStatusReferralDetails,
    },
  };
};
// Status Error
export const onGetStatusReferralDetailsError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetSupplierClosedReferralsStatusesSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    closedReferralsStatuses: payload,
  };
};

export const onGetSupplierClosedReferralsStatusesError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetReferralOutcomesReportSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    outcomesReport: payload,
  };
};

export const onGetManagerKpiReportsSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: null,
  managerKpiReports: payload,
});
